/**
 * Accessibility enhancements for BOGOS Frequently Bought Together widget.
 * The app injects inputs without labels and duplicate checkbox IDs.
 */
(function () {
  const ROOT_SELECTOR = '#bogos-fbt-upsell-view';

  function getProductName(item) {
    const link = item.querySelector('.bogos-fbt-product-title a');
    if (link && link.textContent.trim()) return link.textContent.trim();
    const title = item.querySelector('.bogos-fbt-product-title');
    return title && title.textContent.trim() ? title.textContent.trim() : 'bundle item';
  }

  function ensureVisuallyHiddenLabel(forId, text, insertBefore) {
    if (document.querySelector(`label[for="${forId}"]`)) return;

    const label = document.createElement('label');
    label.className = 'visually-hidden';
    label.htmlFor = forId;
    label.textContent = text;
    insertBefore.insertAdjacentElement('beforebegin', label);
  }

  function enhanceItem(item, index) {
    const productId = item.dataset.productId || String(index);
    const productName = getProductName(item);

    const checkbox = item.querySelector('.bogos-fbt-upsell-body-item-checkbox');
    if (checkbox && !checkbox.dataset.a11yEnhanced) {
      const checkboxId = `bogos-fbt-checkbox-${productId}`;
      checkbox.id = checkboxId;
      checkbox.setAttribute('aria-label', `Include ${productName} in bundle`);
      ensureVisuallyHiddenLabel(checkboxId, `Include ${productName}`, checkbox);
      checkbox.dataset.a11yEnhanced = 'true';
    }

    const qtyInput = item.querySelector('.bogos-fbt-upsell-quantity-input');
    if (qtyInput && !qtyInput.dataset.a11yEnhanced) {
      const qtyId = `bogos-fbt-qty-${productId}`;
      qtyInput.id = qtyId;
      qtyInput.setAttribute('aria-label', `Quantity for ${productName}`);
      ensureVisuallyHiddenLabel(qtyId, `Quantity for ${productName}`, qtyInput);
      qtyInput.dataset.a11yEnhanced = 'true';

      const minusBtn = item.querySelector('.bogos-minus-fbt-btn');
      const plusBtn = item.querySelector('.bogos-plus-fbt-btn');
      if (minusBtn && !minusBtn.getAttribute('aria-label')) {
        minusBtn.setAttribute('aria-label', `Decrease quantity for ${productName}`);
      }
      if (plusBtn && !plusBtn.getAttribute('aria-label')) {
        plusBtn.setAttribute('aria-label', `Increase quantity for ${productName}`);
      }
    }
  }

  function enhanceBogosFbt(root) {
    const items = root.querySelectorAll('.bogos-fbt-upsell-body-classic-item-info');
    if (!items.length) return;

    items.forEach(enhanceItem);

    const addBtn = root.querySelector('.bogos-fbt-footer-button-add');
    if (addBtn && !addBtn.getAttribute('aria-label')) {
      const label = addBtn.textContent.replace(/\s+/g, ' ').trim();
      addBtn.setAttribute('aria-label', label || 'Add selected items to cart');
    }
  }

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const run = () => {
      if (root.querySelector('.bogos-fbt-upsell-container')) {
        enhanceBogosFbt(root);
      }
    };

    run();

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(run);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
